import React from "react";

export default () => (
  <div>
    <p>Hello from EstimatePOS</p>
  </div>
);
